import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map } from 'rxjs/operators';
import { communicationTemplatesActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of, switchMap } from 'rxjs';
import { CommunicationTemplatesService } from '../../services/communication-templates.service';

@Injectable({
  providedIn: 'root',
})
export class CommunicationTemplatesEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private communicationTemplatesService: CommunicationTemplatesService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(communicationTemplatesActions.findAll),
      switchMap(() => {
        return this.communicationTemplatesService.findAll().pipe(
          map((response) =>
            communicationTemplatesActions.findAllSuccess({
              communicationTemplates: response.data,
            }),
          ),
          catchError((error: ApiError) =>
            of(
              communicationTemplatesActions.findAllError({
                error: error.message,
              }),
            ),
          ),
        );
      }),
    ),
  );
}
